import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCsutsnh6aJgE9glPMkKihZC-rbRQ8kdjU",
  authDomain: "image-genrator-f150a.firebaseapp.com",
  projectId: "image-genrator-f150a",
  storageBucket: "image-genrator-f150a.firebasestorage.app",
  messagingSenderId: "638527844270",
  appId: "1:638527844270:web:476bdfc5053b14d3db623f",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
